








































































import Vue from 'vue'
import * as Ux from '@/util/ux_message'

export default Vue.extend({
  data() {
    return {
      item: undefined as Ux.UxMessage | undefined,
      consentInput: null as string,
      consentError: null as string,
      isMessageInRawHTML: false as boolean
    }
  },
  computed: {
    error() {
      return Ux.UxMessageType.ERROR
    },
    warning() {
      return Ux.UxMessageType.WARNING
    },
    info() {
      return Ux.UxMessageType.INFO
    },
    confirmation() {
      return Ux.UxMessageType.CONFIRMATION
    },
    consent() {
      return Ux.UxMessageType.CONSENT
    },
    prompt() {
      return Ux.UxMessageType.PROMPT
    },
    consentString() {
      return this.item.options && this.item.options.consentString || 'Delete'
    }
  },
  methods: {
    show(uxMessage: Ux.UxMessage, isMessageInRawHTML: boolean = false) {
      this.item = uxMessage
      this.isMessageInRawHTML = isMessageInRawHTML
      this.$refs['modal-sm-d'].show()
    },
    clear() {
      this.item = undefined
      this.consentInput = null
      this.consentError = null
    },
    async ok(){
      if (this.item?.type === this.consent) {
        if (!this.consentInput || this.consentInput.toLowerCase() !== this.consentString.toLowerCase()) {
          this.consentError = `Please type ${this.consentString} above or cancel this action.`
          return false;
        }
      }
      if(this.item?.type === this.prompt && this.item.options)
      this.item.options.returnInfo=this.consentInput
      this.item?.Ok();
      this.clear();
      this.$refs['modal-sm-d'].hide();
    },
    cancel(){
        this.item?.Cancel();
        this.clear();
        this.$refs['modal-sm-d'].hide();
    },
  }
})
